import { Pipe, PipeTransform, inject } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

/**
 * @whatItDoes Runs html string through `DomSanitizer.bypassSecurityTrustHtml()`
 *
 * @howToUse
 *
 * ```
 * <div [innerHTML]="content | trustAsHtml"></div>
 * ```
 *
 * @stable
 */
@Pipe({ standalone: true, name: 'trustAsHtml', pure: true })
export class TrustAsHtmlPipe implements PipeTransform {
    private sanitizer = inject(DomSanitizer);

    public transform(value: string | null | undefined): SafeHtml {
        return this.sanitizer.bypassSecurityTrustHtml(value || '');
    }
}
